import React from "react";

const LeftArrow = ({ onClickHandle, isActive }: any) => (
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" onClick={onClickHandle} xmlns="http://www.w3.org/2000/svg">
        <path d="M0.279184 9.00163L8.42575 0.515625L11.1406 3.34562L5.70894 9.00163L11.1406 14.6576L8.42575 17.4876L0.279184 9.00163Z" fill={isActive ? "#5F67E0" : "#c7c7c7"} />

    </svg>

);

export default LeftArrow;

